import React from 'react'
import OnBoarding from 'modules/onboarding_one'
import { useTheme } from '@mui/styles'
import { Box, Dialog, Slide, Container } from '@mui/material'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const TasteTips = ({ open, setOpen }) => {
  const theme = useTheme()

  const handleClose = () => {
    setOpen(!open)
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', m: 'auto' }}>
     <Dialog
        fullScreen={theme.popUpsWidth}
        sx={{
          display: 'flex',
          width: '100vw',
          // maxWidth: '450px',
          m: 'auto',

          '.MuiBackdrop-root': {
            width: '100vw',
            // maxWidth: '450px',
            m: 'auto'
          },
          '.MuiDialog-container': {
            display: 'flex',
            alignItems: 'flex-end'
          },
          '.MuiPaper-root': {
            width: '100vw',
            // maxWidth: '450px',
            bgcolor: 'transparent'
          }
          // '.MuiDialog-paper': { ml:-5 },
        }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
      <Container disableGutters sx={{ '&.MuiContainer-root': { width: '100vw', maxWidth: '450px', bgcolor: 'primary.main' } }}>
        <OnBoarding tasteTips={true} handleClose={handleClose} />
      </Container>
    </Dialog>
    </Box>
  )
}

export default TasteTips
